/* eslint-disable jsx-a11y/control-has-associated-label */

import React, { Component } from "react"
import PropTypes from "prop-types"
import { X } from "react-feather"

class SearchBar extends Component {
  onValueChange = (event) => {
    const { onSearchChange } = this.props
    const searchValue = event.target.value || ""

    onSearchChange(searchValue)
  }

  clearSearch = () => {
    const { onSearchChange } = this.props
    this.searchInput.value = ""

    onSearchChange("")
  }

  render() {
    const { resultCount, totalCount, placeholder } = this.props

    return (
      <div className="search-bar">
        <div className="search-bar__count">
          <p className="search-bar__count-content">
            {`Showing ${resultCount} results out of ${totalCount}`}
          </p>
        </div>
        <div className="search-bar__search form-control">
          <div className="form-control__content">
            <div className="form-control__faux">
              <button
                className="search-bar__btn__clear"
                type="button"
                onClick={this.clearSearch}
              >
                <X />
              </button>
              <input
                ref={(ref) => (this.searchInput = ref)}
                type="text"
                className="form-control__input form-control__input--input"
                placeholder={placeholder}
                onChange={this.onValueChange}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

SearchBar.defaultProps = {
  resultCount: 0,
  totalCount: 0,
  placeholder: "Search ...",
  onSearchChange: () => {},
}

SearchBar.propTypes = {
  resultCount: PropTypes.number,
  totalCount: PropTypes.number,
  placeholder: PropTypes.string,
  onSearchChange: PropTypes.func,
}

export default SearchBar
